import React, { FunctionComponent } from 'react';

const TermAndConditions: FunctionComponent = () => <div className="borderStyle">Term and Conditions</div>;

export default TermAndConditions;
